import type { DamageType } from '@/common/damage';
import { axios } from '@/lib/utils/axios';
import { getResponse } from '../common';
import { API_URLS } from '../query.client';

export type MoveDamagePayload = {
	inspectionId: string;
	assetId: string;
};

export async function moveDamage(
	damageId: string,
	payload: MoveDamagePayload
): Promise<DamageType | null> {
	// We send the payload directly because we are only patching the relationship IDs
	const response = await axios.patch(`${API_URLS.DAMAGES.INDEX}/${damageId}`, payload);

	return getResponse<DamageType>(response.data);
}
